import { GROUP_TYPE_KEYS } from '@pushly/pquery'

/** The group keys the wire format defines, from the engine rather than a copy kept here. */
const GROUP_KEYS = [...GROUP_TYPE_KEYS]

/**
 * True when a query document holds at least one condition anywhere in its groups.
 *
 * A group is an object whose only content is a list under a group key (`and`, `or`, `and_not`); anything else is a
 * condition. An empty group — the scaffolding the builder opens on — holds none, which is what
 * lets a switch that was turned on and never filled in be told apart from a real restriction.
 */
export function documentHasCondition(document: unknown): boolean {
    if (!document || typeof document !== 'object') return false

    const node = document as Record<string, unknown>
    const groupKey = GROUP_KEYS.find((key) => Array.isArray(node[key]))

    if (!groupKey) return Object.keys(node).length > 0

    return (node[groupKey] as unknown[]).some(documentHasCondition)
}
